import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';
import evn from "./../../../../../actions/index";//action的所有事件
import { connect } from "react-redux";//联系store的组件
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import $ from 'jquery';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import Crumbs from './../../../Crumbs/Crumbs';
import CaseDetailsInfoModal from "./../../../Common/CaseDetailsInfoModal";//登记单详情
import "./../style.css";
import { Hcurl } from "./../../../../../constants/index";//获取公共路径
import moment from 'moment'
import { Form, Row, Col, Input, Button, Table, LocaleProvider, Modal, Select,DatePicker  } from 'antd';
const confirm = Modal.confirm;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { Option } = Select;
const history = createHistory();

//表格
var _this = this;
const DealStateArr = [,'和解成功','和解失败(未达成一致)','和解失败(主动拒绝)','和解失败（已逾期）','处理中','-']; //处理结果数据
const DealResultArr = [,'待处理','已处理']
class TableWaper extends Component {
    componentDidMount() {
        _this = this;
    }
    componentWillMount(){
        _this = this;
    }
    state = {
        data: [], //数据源
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        loading: false,
        pagetotalCount: 0,
        display: 'none',
        _record: "",
        sorters: 'ReceiveTime desc'
    }
    
    

    // 表格改变
    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination: pagination,
        });
        if (Object.keys(sorter).length !== 0) {
            if (sorter.field == "ReceiveTime" && sorter.order!=undefined) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "ReceiveTime desc" : "ReceiveTime"
                })
            }else if(sorter.field == "ReceiveTime" && sorter.order==undefined){
                _this.setState({
                    sorters:  "ReceiveTime desc" 
                })
            }
            if (sorter.field == "CI_BJDate"&& sorter.order!=undefined ) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "CI_BJDate desc" : "CI_BJDate"
                })
            }else if(sorter.field == "CI_BJDate"&& sorter.order==undefined){
                _this.setState({
                    sorters:  "CI_BJDate desc" 
                })
            }

        }
        setTimeout(function () {
            _companyList.tableData()
        }, 20)
    };
    componentDidMount() {
        _this = this;
    }

    recordCheck=(record)=>{
        $.ajax({
            url: Hcurl + '/Business/AddViewLog',
            type: "post",
            data: {
                CI_Code: record.CI_Code,
                UserCode: EventSet.getUserInfo().CU_Code,//当前登录人Code
                UserName: EventSet.getUserInfo().userName,//当前登录人名称
            },
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
              
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    //点击显示登记编号弹框
    ModalCase = (record) => {
        this.recordCheck(record)
        _companyList.props.dispatch(evn.showCaseInfo(record.ID, 'CompanyCase'))
    }

    render() {
        const { pagetotalCount, pagination } = this.state
        this.columns = [
        {
            title: '登记编号',
            fixed:'left',
            render: (record) => {
                return (
                    <div>
                        <a style={{ marginRight: 10 }} onClick={v => this.ModalCase(record)}>{record.CI_Code}</a>
                    </div>
                )
            },
            width: 140,
            key: "1"
        },
        {
            title: '信息类别',
            dataIndex: 'CI_Type',
            key: "2",
            width:100
        },
        {
            title: '投诉人姓名',
            dataIndex: 'CI_UserName',
            key: "3",
            width:180
        },
        {
            title: '投诉人电话',
            dataIndex: 'CI_UserPhone',
            key: "4",
            width:120
        },
        {
            title: '商品/服务',
            dataIndex: 'CI_ShopName',
            key: "5",
            // width:180
        },
        {
            title: '接收时间',
            dataIndex: 'ReceiveTime',
            sorter: true,
            key: "6",
            width:140,
            render:(record)=>{
                if(record){
                    return (moment(record).format('YYYY-MM-DD HH:mm'))
                }else{
                    return ('-')
                }
            }
        },
        {
            title: '办理时间',
            dataIndex: 'CI_BJDate',
            sorter: true,
            key: "7",
            width:140,
            render:(record)=>{
                if(record){
                    return (moment(record).format('YYYY-MM-DD HH:mm'))
                }else{
                    return ('-')
                }
            }
        },
        {
            title: '处理结果',
            dataIndex: 'DealResult',
            key: "9",
            width:160,
            fixed: 'right',
            render:(record) => {
                return DealStateArr[record]
            }
        },
        {
            title: '处理状态',
            dataIndex: 'DealState',
            key: "8",
            width:100,
            fixed: 'right',
            render:(record) => {
                return DealResultArr[record]
            }
        }
        
    ];
        return (
            <div style={{ position: "relative" }}>
                <LocaleProvider locale={zhCN}>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.data}
                        rowKey={record => record.CI_Code}
                        onChange={this.handleTableChange}
                        pagination={this.state.pagination}
                        loading={this.state.loading}
                        size="middle"
                        scroll={{ x: 1400 }}
                        bordered
                    />

                </LocaleProvider>
                <span className='tableTotal' style={{ display: this.state.display }}>
                    共 {pagetotalCount} 条记录 第 {pagination.current} / {pagination.total % pagination.pageSize == 0 ? Math.floor(pagination.total / pagination.pageSize) : Math.floor(pagination.total / pagination.pageSize) + 1} 页</span>
            </div>
        )
    }
}

var _companyList = null;
var ValueArray = [{
    CI_Code: "",
    receiveTime:[,],
    dealEndTime:[,],
    UserName: "",
    UserPhone: "",
    Content:'',
    CI_Type: "",
    DealResult:"",
    DealState:"",
}]

// 主框架
class App extends Component {
    state = {
        autoHeight: "",
        companyList: 0,//没有选择企业
        span: 24,
        companyAllList: [],//已选企业列表
        display: "none",
        disabled: true,
        //_isMounted: false
    }

    autoHeight = () => {  //内容区域高度自适应
        let autoHeight = window.innerHeight - 429;
        this.setState({
            autoHeight: autoHeight
        })
    }

    //组件加载完成后
    componentDidMount() {
        ValueArray = [{
            CI_Code: "",
            receiveTime:[,],
            dealEndTime:[,],
            UserName: "",
            UserPhone: "",
            Content:'',
            CI_Type: "",
            DealResult:"",
            DealState:"",
        }]
        setTimeout(() => {
            _companyList.tableData()
        }, 20);
        _companyList = this;
        this.autoHeight();
        EventSet.NavShow(this, "/Content/Business/CompromiseListOrder/proces", "Compromise")//显示菜单
    }

    tableData = () => {   //获取列表数据
        
        _this.setState({ loading: true });
        const pagination = { ..._this.state.pagination };
        const _data = {
            CI_Code: ValueArray[0].CI_Code ? ValueArray[0].CI_Code.trim() : '',
            beginReceiveTime:(ValueArray[0].receiveTime&&ValueArray[0].receiveTime[0]) ? moment(ValueArray[0].receiveTime[0]).format('YYYY-MM-DD') : '',
            EndReceiveTime:(ValueArray[0].receiveTime&&ValueArray[0].receiveTime[1]) ? moment(ValueArray[0].receiveTime[1]).format('YYYY-MM-DD') : '',
            beginDealEndTime:(ValueArray[0].dealEndTime&&ValueArray[0].dealEndTime[0]) ? moment(ValueArray[0].dealEndTime[0]).format('YYYY-MM-DD') : '',
            EndDealEndTime:(ValueArray[0].dealEndTime&&ValueArray[0].dealEndTime[1])? moment(ValueArray[0].dealEndTime[1]).format('YYYY-MM-DD') : '',
            UserName: ValueArray[0].UserName ? ValueArray[0].UserName.trim() : '', //去除两边空格
            UserPhone: ValueArray[0].UserPhone ? ValueArray[0].UserPhone.trim() : '',  //去除两边空格
            Content:ValueArray[0].Content ? ValueArray[0].Content.trim() : '',  //去除两边空格
            CI_Type:ValueArray[0].CI_Type,
            DealResult:ValueArray[0].DealResult,
            DealState:ValueArray[0].DealState,
            ComCode:EventSet.getUserInfo()['xxhjcompanycode'],
            userCode : EventSet.getUserInfo()['CU_Code'],
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
            order: _this.state.sorters
        }
        $.ajax({
            url: Hcurl + '/Business/GetCompanyAllCase',
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data: _data,
            success: function (data) {
                

                if (data != null && data != '') {
                    _this.setState({
                        data: data.Table,
                        pagetotalCount: data.Table1[0].Column1,
                        pagination: pagination,
                    })
                    if (data.Table.length !== 0) {
                        _this.setState({
                            display: "block",
                        })
                    } else {
                        _this.setState({
                            display: "none",
                        })
                    }
                    pagination.total = data.Table1[0].Column1;
                }
                _this.setState({
                    loading: false,
                })
                setTimeout(function () {
                    if (data != null && data != '') {
                        if (data.Table1[0].Column1 > 0) {
                            _companyList.setState({ disabled: false })
                        } else {
                            _companyList.setState({ disabled: true })
                        }
                    }
                }, 20);
            },
            error: function (res) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })

            }
        })
    }

    //查询条件搜索
    searchClick = () => {
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            const values = {
                ...fieldsValue,
            };
            ValueArray[0].CI_Code = values.CI_Code;
            ValueArray[0].receiveTime = values.receiveTime;
            ValueArray[0].dealEndTime = values.dealEndTime;
            ValueArray[0].UserName = values.UserName;
            ValueArray[0].UserPhone = values.UserPhone;
            ValueArray[0].Content = values.Content;
            ValueArray[0].CI_Type = values.CI_Type;
            ValueArray[0].DealResult = (values.DealResult && values.DealResult.length != 0) ? values.DealResult.join(';') : '' ;
            ValueArray[0].DealState = values.DealState;

            const pagination = { ..._this.state.pagination };
            pagination.current = 1;
            _this.setState({
                pagination: pagination
            })
            setTimeout(function () {
                _companyList.tableData();
            }, 20)

        })
    }
    //重置搜索调解
    reSet = () => {
        this.props.form.resetFields();
    }

    //到处CSV
    exportCsv = () => {
        const _data = {
            CI_Code: ValueArray[0].CI_Code ? ValueArray[0].CI_Code.trim() : '',
            beginReceiveTime:(ValueArray[0].receiveTime&&ValueArray[0].receiveTime[0]) ? moment(ValueArray[0].receiveTime[0]).format('YYYY-MM-DD') : '',
            EndReceiveTime:(ValueArray[0].receiveTime&&ValueArray[0].receiveTime[1]) ? moment(ValueArray[0].receiveTime[1]).format('YYYY-MM-DD') : '',
            beginDealEndTime:(ValueArray[0].dealEndTime&&ValueArray[0].dealEndTime[0]) ? moment(ValueArray[0].dealEndTime[0]).format('YYYY-MM-DD') : '',
            EndDealEndTime:(ValueArray[0].dealEndTime&&ValueArray[0].dealEndTime[1])? moment(ValueArray[0].dealEndTime[1]).format('YYYY-MM-DD') : '',
            UserName: ValueArray[0].UserName ? ValueArray[0].UserName.trim() : '', //去除两边空格
            UserPhone: ValueArray[0].UserPhone ? ValueArray[0].UserPhone.trim() : '',  //去除两边空格
            Content:ValueArray[0].Content ? ValueArray[0].Content.trim() : '',  //去除两边空格
            CI_Type:ValueArray[0].CI_Type,
            DealResult:ValueArray[0].DealResult,
            DealState:ValueArray[0].DealState,
            ComCode:EventSet.getUserInfo()['xxhjcompanycode'],
            userCode : EventSet.getUserInfo()['CU_Code']
        }
        $.ajax({
            url: Hcurl + '/Business/ExportCSV',
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data: _data,
            success: function (data) {
                if(data){
                    const tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = data;
                    // 兼容：某些浏览器不支持HTML5的download属性
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }
                    // 挂载a标签
                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                }
                // let blob = new Blob([data]);
                // const fileName = '工单数据.csv'
                // if (typeof window.navigator.msSaveBlob !== "undefined") {
                //     // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
                //     window.navigator.msSaveBlob(blob, decodeURI(fileName));
                // }else{
                //     // 创建新的URL并指向File对象或者Blob对象的地址
                //     const blobURL = window.URL.createObjectURL(blob);
                //     // 创建a标签，用于跳转至下载链接
                //     const tempLink = document.createElement("a");
                //     tempLink.style.display = "none";
                //     tempLink.href = blobURL;
                //     tempLink.setAttribute("download", decodeURI(fileName));
                //     // 兼容：某些浏览器不支持HTML5的download属性
                //     if (typeof tempLink.download === "undefined") {
                //         tempLink.setAttribute("target", "_blank");
                //     }
                //     // 挂载a标签
                //     document.body.appendChild(tempLink);
                //     tempLink.click();
                //     document.body.removeChild(tempLink);
                //     // 释放blob URL地址
                //     window.URL.revokeObjectURL(blobURL);
                // }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    render() {
        const { autoHeight } = this.state;
        const style = {
            minHeight: autoHeight
        };
        const formItemLayout = {
            labelCol: {
                xxl: { span: 4 },
                xl: { span: 6 },
                lg: { span: 8 },
                md: { span: 10 },
            },
            wrapperCol: {
                xxl: { span: 18 },
                xl: { span: 16 },
                lg: { span: 14 },
                md: { span: 10 },
            }
        };
        const style1 = {
            marginRight: 25,
        };
        const { getFieldDecorator } = this.props.form;
        return (
            <div id={'Company'} >
                <Crumbs title={"先行和解 / 工单查询"} />
                <CaseDetailsInfoModal />
                <div className={'Company'} style={style}>
                    <Form onSubmit={this.handleSubmit} className='formSearch' style={{ marginLeft: 10 }}>
                        <Row>
                            <Col span={8}>
                                <FormItem
                                    label="登记编号"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('CI_Code')(
                                        <Input placeholder='请输入登记编号' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="接收时间"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('receiveTime')(
                                        <RangePicker style={{ width:'100%' }} placeholder='请选择接收时间' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="办理时间"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('dealEndTime')(
                                        <RangePicker style={{ width:'100%' }} placeholder='请选办理时间' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="投诉人姓名"
                                    {...formItemLayout}
                                >
                                    {/* ,{
                                        getValueFromEvent : (e) => e.target.value.replace(/(^\s*)|(\s*$)/g, '')
                                    } */}
                                    {getFieldDecorator('UserName')(
                                        <Input placeholder='请输入投诉人姓名' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="投诉人电话"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('UserPhone')(
                                        <Input placeholder='请输入投诉人电话' />
                                    )}
                                </FormItem>
                            </Col>
                            {/* 投诉内容 */}
                            <Col span={8}>
                                <FormItem
                                    label="投诉内容"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Content')(
                                        <Input placeholder='请输入投诉内容' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="信息类别"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('CI_Type',{initialValue:''})(
                                        
                                        <Select placeholder='请选择信息类别'>
                                        <Option key={1} value="">全部</Option>
                                        <Option key={2} value="投诉">投诉</Option>
                                        <Option key={3} value="无理由退货">无理由退货</Option>
                                      </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="处理结果"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('DealResult')(
                                        
                                        <Select placeholder='请选择处理结果' mode="multiple">
                                        {/* <Option key={0} value={0}>全部</Option> */}
                                        <Option key={1} value={1}>和解成功</Option>
                                        <Option key={2} value={2}>和解失败（未达成一致）</Option>
                                        <Option key={3} value={3}>和解失败（主动拒绝）</Option>
                                        <Option key={4} value={4}>和解失败（已逾期）</Option>
                                        {/* <Option key={5} value={5}>处理中</Option> */}
                                      </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="处理状态"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('DealState',{initialValue:''})(
                                        
                                    <Select placeholder='请选择处理状态' >
                                        {/* <Option key={0} value={0}>全部</Option> */}
                                        <Option key={0} value="">全部</Option>
                                        <Option key={1} value={1}>待处理</Option>
                                        <Option key={2} value={2}>已处理</Option>
                                      </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8} >
                                    <Button onClick={this.exportCsv}>导出EXCEL</Button>
                                </Col>
                            <Col span={16}>
                                <div className='searchBtn'>
                                    <span className='searchSpan'>
                                        <Button type="primary" htmlType="submit" style={style1} onClick={this.searchClick}>搜索</Button>
                                        <Button type="" onClick={this.reSet}>重置</Button>
                                    </span>
                                </div>
                            </Col>
                          
                        </Row>
                       
                    </Form>
                    <div style={{ width: "100%", margin: "0 auto" }}>
                        {/* <div style={{ marginTop: 30 }}>
                            <Row>
                                <Col span={8} >
                                    <Button onClick={this.exportCsv}>导出EXCEL</Button>
                                </Col>
                            </Row>
                        </div> */}
                        <div className='TableWaper' style={{ width: "100%" }}>
                            <TableWaper />
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}
const AppWrapped = Form.create()(App);
export default connect()(AppWrapped)


// WEBPACK FOOTER //
// ./src/components/Content/Business/Compromise/CompromiseListOrder/CompromiseListOrder.js